module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-75a0283c96dc23c72069515f0ac1ca49.png";